import { registerComponent } from '@gig/magic-common';
import StepProgressBarComponent from './step-progress-bar.vue.js';

var StepProgressBar = registerComponent(StepProgressBarComponent);

export { StepProgressBar };
